import script from "./StandardList.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardList.vue?vue&type=script&setup=true&lang=js"

import "./StandardList.vue?vue&type=style&index=0&id=195801c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195801c3"]])

export default __exports__